import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { uniqueId } from 'lodash-es';
import { startWith } from 'rxjs';

import { OAuth2CredentialType, OAuth2FlowType } from '@blaze-shared/api-contracts-domain';
import { ButtonComponent, TooltipDirective } from '@blaze-shared/shared-ui';

import { ApiBuilderStore } from '../+state/api-builder.store';
import { ApiOauth2AuthorizationForm } from '../api-builder.model';

@UntilDestroy()
@Component({
  selector: 'blaze-oauth-authorization-form',
  imports: [
    CommonModule,
    ButtonComponent,
    FormsModule,
    MatButtonToggleGroup,
    MatButtonToggleModule,
    MatIconModule,
    ReactiveFormsModule,
    TooltipDirective,
  ],
  templateUrl: './oauth-authorization-form.component.html',
  styleUrls: ['./oauth-authorization-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OauthAuthorizationFormComponent implements OnInit {
  private readonly apiBuilderStore = inject(ApiBuilderStore);

  readonly formCtrl = input.required<FormGroup<ApiOauth2AuthorizationForm>>();

  readonly formId = uniqueId('oauth-authorization-form');
  readonly CredentialType = OAuth2CredentialType;

  readonly useClientCredentials = signal(false);
  readonly credentialType = signal<OAuth2CredentialType | undefined>(undefined);

  ngOnInit(): void {
    this.formCtrl()
      .valueChanges.pipe(untilDestroyed(this), startWith(this.formCtrl().value))
      .subscribe(({ oAuth2CredentialType, oAuth2FlowType }) => {
        this.useClientCredentials.set(oAuth2FlowType === OAuth2FlowType.ClientCredentials);
        this.credentialType.set(oAuth2CredentialType);
      });
  }

  authorize(): void {
    if (this.formCtrl().invalid) {
      return;
    }

    this.apiBuilderStore.openOAuthPopup();
  }
}
